export default "https://assets-v2.scaler.com/packs/images/not-found.6543f2.svg";